import * as Yup from "yup";
import { RequirementDefinitionTemplateForm } from "../../types";
import { FormPartialAcceptWingspanMasterPolicy } from "../FormPartialAcceptWingspanMasterPolicy";
import { WarningWingspanIsNotAgent } from "../WarningWingspanIsNotAgent";
import {
  AGGREGATE_LIMIT_MINIMUM_COMMON,
  DEDUCTIBLE_CAP_COMMON,
  FormPartialProfessionalLiability,
  PER_CLAIM_LIMIT_MINIMUM_COMMON
} from "../FormPartialProfessionalLiability";
import { CreateRequirementDefinitionInsuranceCoveragePartialForm } from "../../../../modules/InsuranceCoverage/createRequirementDefinition/types";

type ProfessionalLiabilityValues = {
  acceptWingspanMasterPolicy: boolean;
  perClaimLimitMinimum: string;
  totalCoverageLimitMinimum: string;
  contractorDeductibleMaximum: string;
};
/*
https://github.com/wingspanHQ/benefits/blob/staging/src/lib/interfaces/insuranceRequirement.ts
 */

export const PROFESSIONAL_LIABILITY_FORM: RequirementDefinitionTemplateForm<
  ProfessionalLiabilityValues,
  CreateRequirementDefinitionInsuranceCoveragePartialForm
> = {
  getDefaultValues: template => ({
    acceptWingspanMasterPolicy: true,
    perClaimLimitMinimum: `${PER_CLAIM_LIMIT_MINIMUM_COMMON}`,
    totalCoverageLimitMinimum: `${AGGREGATE_LIMIT_MINIMUM_COMMON}`,
    contractorDeductibleMaximum: `${DEDUCTIBLE_CAP_COMMON}`
  }),
  mapFormData(values, template) {
    const {
      acceptWingspanMasterPolicy,
      perClaimLimitMinimum,
      totalCoverageLimitMinimum,
      contractorDeductibleMaximum,
      ...other
    } = values;

    return {
      ...other,
      name: template.name,
      coverages: [
        {
          policyType: "ProfessionalLiability",
          appliedProvisions: [],
          limits: [
            {
              limitType: "PerClaim",
              amount: Number(perClaimLimitMinimum),
              currency: "USD"
            },
            {
              limitType: "PolicyAggregate",
              amount: Number(totalCoverageLimitMinimum),
              currency: "USD"
            },
            {
              limitType: "Deductible",
              amount: Number(contractorDeductibleMaximum),
              currency: "USD"
            }
          ],
          acceptedSourceTypes: acceptWingspanMasterPolicy
            ? ["InsuranceImport", "PlanEnrollment"]
            : ["InsuranceImport"]
        }
      ]
    };
  },
  partialForm: (
    <>
      <WarningWingspanIsNotAgent />
      <FormPartialAcceptWingspanMasterPolicy switchLabel="Accept Wingspan's PL/GL Master Policy" />
      <FormPartialProfessionalLiability />
    </>
  ),
  validationSchema: Yup.object().shape({
    acceptWingspanMasterPolicy: Yup.boolean().required("Required"),
    perClaimLimitMinimum: Yup.string().required("Required"),
    totalCoverageLimitMinimum: Yup.string().required("Required"),
    contractorDeductibleMaximum: Yup.string().required("Required")
  })
};
